import { Link } from 'react-router';

const tasks = [
  { to: '/guides/who-is-responsible', title: 'Find who to claim from', text: 'Identify the council or highway authority responsible for the road.' },
  { to: '/guides/pothole-claim-letter-template', title: 'Use a free claim letter template', text: 'Prepare your own letter with the incident details and evidence checklist.' },
  { to: '/guides/request-road-inspection-records', title: 'Request road inspection records', text: 'Use the request templates to obtain records for the road and incident date.' },
  { to: '/blog/council-rejected-your-pothole-claim', title: 'Check a rejected pothole claim', text: 'Understand the council response and which evidence to check next.' },
];

export function ClaimHelp() {
  return (
    <section className="bg-white py-16" aria-labelledby="claim-help-heading">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <h2 id="claim-help-heading" className="font-display text-3xl font-bold text-brand-950">Help with your pothole damage claim</h2>
        <p className="mt-4 max-w-3xl text-lg text-surface-800">
          In England and Wales you claim the cost of pothole damage from the authority responsible for the road,
          usually your local council or National Highways, under the Highways Act 1980. There is no fee to claim
          and you submit it yourself. Authorities often refuse claims under the Section 58 defence, so your
          evidence and the authority&apos;s own inspection records shape the response.
        </p>
        <p className="mt-4 max-w-3xl text-surface-700">
          <Link to="/guides/how-to-claim-for-pothole-damage" className="font-semibold text-brand-700 underline underline-offset-4 hover:text-brand-800">
            Read the step-by-step guide to claiming for pothole damage
          </Link>
          , or start with the step you need below. These guides and templates are free to read, without an account.
        </p>
        <ul className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {tasks.map((task) => (
            <li key={task.to}>
              <Link to={task.to} className="block h-full rounded-xl border border-surface-200 p-6 hover:border-brand-400 hover:bg-brand-50">
                <h3 className="font-semibold text-brand-800 underline underline-offset-4">{task.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-surface-700">{task.text}</p>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
